<template>
  <div>
    <ion-img class="img" src="/assets/image/mic-1.png"></ion-img>
  </div>
</template>

<script>
import {IonImg} from "@ionic/vue";

export default {
  name: "TestMicStart",
  components: {
    IonImg
  }
}
</script>

<style scoped>

</style>